import React, { useEffect, useState } from "react";
import "./Souscription.css";
import { useHistory, useLocation } from "react-router";
import NavBar from "./Components/NavBar";
import contractService from "../../services/contract/contractService";
const InformationCard = () => {
  const history = useHistory();
  const location = useLocation();
  const contractCarte = location.state
  const [dataValue, setDataValue]= useState([])
  console.log(contractCarte);

 React.useEffect(() => {

    contractService.getvalueinfobyidcontract(contractCarte.idcontract).then(res=>{
        if(res.status=200){
           setDataValue(res.data)
        }
    })

 }, []);

  return (
    <div className="row col-lg-12 col-md-12 col-sm-12 col-12 margin0">
      <NavBar text="Mes Produits Assurés" />
      <div className="row col-lg-12 col-md-12 col-sm-12 col-12 form-souscription d-flex-j-c">
        <div className="row col-md-8 testwidth">
          <div>
          </div>
      {dataValue.map((ele, index) => (
        <div className="product-card" key={index}>
          <div className="card-header-flex">
            {/* Icône du smartphone à gauche */}
            <div className="product-icon">
              <img  src={
                        `${process.env.PUBLIC_URL}/assets/images/` +
                        ele.productName +
                        ".svg"
                      } alt={ele.productName} />
            </div>

            <div className="product-details">
              <h4 className="product-title">
                <span className="blue-icon"></span> {ele.productName}
              </h4>
              
              {/* On filtre les paramètres textuels uniquement ici */}
              <div className="details-grid">
                {ele.value_info_list
                  .filter(el => !["photoAv", "photoAr", "video"].includes(el.parameter))
                  .map((el, indx) => (
                    <p key={indx}><strong>{el.parameter} :</strong> {el.value}</p>
                  ))}
              </div>
            </div>
          </div>

          {/* Section des boutons en bas à droite */}
          <div className="card-actions">
            {ele.value_info_list.map((el, indx) => {
              if (el.parameter === "photoAv") {
                return <a href={el.value} className="btn-action btn-blue" key={indx}>📷 Photo AV</a>;
              }
              if (el.parameter === "photoAr") {
                return <a href={el.value} className="btn-action btn-blue" key={indx}>📷 Photo AR</a>;
              }
              if (el.parameter === "video") {
                return <a href={el.value} className="btn-action btn-blue-dark" key={indx}>📹 Vidéo</a>;
              }
              return null;
            })}
          </div>
        </div>
      ))}
          <div>
            <button
              type="button"
              class="btn btn-primary btn-annuler"
              onClick={() => history.goBack()}
            >
              Retour
            </button>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default InformationCard;
